import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  invoicesList: null,
  invoicesListError: null,
  invoicesReportListLoading: null,
  invoicesReportList: null,
  invoicesReportListError: null,

  labelInvoiceLoading: false,
  labelInvoiceList: null,
  labelInvoiceListError: null,
  success: null,
  error: null
};

export const invoicesReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.GET_INVOICES_LIST_START:
      return {...state, loading: true, invoicesListError: null};
    case actionTypes.GET_INVOICES_LIST_SUCCESS:
      return {...state, loading: false, invoicesListError: null, invoicesList: action.payload,}
    case actionTypes.GET_INVOICES_LIST_FAILURE:
      return {...state, loading: false, invoicesListError: action.payload, invoicesList: null,};

    case actionTypes.GET_INVOICES_REPORT_LIST_START:
      return {...state, invoicesReportListLoading: true, invoicesReportList: null, invoicesReportListError: null};
    case actionTypes.GET_INVOICES_REPORT_LIST_SUCCESS:
      return {
        ...state,
        invoicesReportListLoading: false,
        invoicesReportList: action.payload,
        invoicesReportListError: null,
      }
    case actionTypes.GET_INVOICES_REPORT_LIST_FAILURE:
      return {
        ...state,
        invoicesReportListLoading: false,
        invoicesReportList: null,
        invoicesReportListError: action.payload.error,
      };

    // label invoice
    case actionTypes.GET_LABEL_INVOICES_LIST_START:
      return {...state, labelInvoiceLoading: true, labelInvoiceList: null, labelInvoiceListError: null};
    case actionTypes.GET_LABEL_INVOICES_LIST_SUCCESS:
      return {...state, labelInvoiceLoading: false, labelInvoiceList: action.payload, labelInvoiceListError: null,}
    case actionTypes.GET_LABEL_INVOICES_LIST_FAILURE:
      return {
        ...state,
        labelInvoiceLoading: false,
        labelInvoiceListList: null,
        labelInvoiceListError: action.payload.error,
      };

    case actionTypes.UPDATE_INVOICE_START:
      return {...state, loading: true, success: null, error: null};

    case actionTypes.GENERATE_INVOICE_START:
      return {...state, loading: true, success: null, error: null};
    case actionTypes.GENERATE_INVOICE_SUCCESS:
      return {...state, loading: false, success: action.payload.success, error: null, rejected: action.payload.rejected}
    case actionTypes.GENERATE_INVOICE_FAILURE:
      return {...state, loading: false, success: null, error: action.payload.error,};

    case actionTypes.REJECTED_INVOICES_HANDLER:
      return {...state, rejected: action.payload};

    case actionTypes.INVOICES_ERROR_HANDLER:
      return {...state, invoicesListError: action.payload, error: action.payload, success: action.payload,};
    default:
      return {...state};
  }
};


// cp_name display in label listing
